<template>
  <div :class="$style.search">
    <input v-model="modelValue" :class="$style.searchInput" :placeholder="placeholder" type="text">
    <button :class="$style.searchBtn" @click="$emit('submit')">
      <i class="el-icon-search" />
    </button>
  </div>
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";
import { useVModel } from "@vueuse/core";

export default defineComponent({
	name: "SearchField",
	props: {
		value: String,
		placeholder: String
	},
	emits: ["submit"],
	setup(props, { emit }) {
		const modelValue = useVModel(props, "value", emit, {
			eventName: "input"
		});
		// function onInput(event) {
		//     modelValue.value = event.val
		// }
		return { modelValue };
	}
});
</script>
<style lang="scss" module>
.search {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.searchInput {
  background-color: transparent;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  height: 2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.searchBtn {
  height: 2rem;
  width: 2rem;
}
</style>